import React from 'react'

const Footer = () => {
    return <div className="bg-gray-50"></div>
}

export default Footer
